import React, { useEffect, useState } from "react";
import axios from "axios";
import { decryptData } from "../../../utils/valueDecrypt";

function NewVideoConsult(props) {
  let loginData = sessionStorage.getItem("login_result");
  let loginDataObject = loginData ? JSON.parse(loginData) : null;
  const { selectedPatient } = props;
  const [url, setUrl] = useState("");
  const [permissionsGranted, setPermissionsGranted] = useState(false);

  useEffect(() => {
    if (selectedPatient?.appointmentId) {
      getLink();
    }
  }, [selectedPatient]);

  const getLink = async () => {
    try {
      const payload = {
        createdDate: new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " "),
        merchantId: "hslA/69EPSD7qXTYAqWxuCqnq8KLo8Q3AFgvFVKsIBk=",
        merchantUserId: "HELIXO",
        modifiedDate: new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " "),
        saltkey: "ojKdN1zB/MdTtJ1hBoIzVtRK60oyos5x29koJaadxL8=",
        uniqueId: selectedPatient.appointmentId,
        userName: loginDataObject.user.firstName,
      };

      const response = await axios.post(
        "https://api.v-connect.helixotech.com/HelixoConnect/join-call",
        payload
      );
      const decryptedString = decryptData(response.data.data);

      const decryptedJson =
        typeof decryptedString === "string"
          ? JSON.parse(decryptedString)
          : decryptedString;

      setUrl(decryptedJson.url);

      if (props.fetchUrl) {
        props.fetchUrl(decryptedJson.url);
      }
    } catch (error) {
      console.error("Error:", error);

      if (error.response) {
        console.log("Status:", error.response.status);
        console.log("Response:", error.response.data);
      } else if (error.request) {
        console.log("No response received");
      } else {
        console.log("Request error:", error.message);
      }
    }
  };

  if (!url) {
    return <div></div>;
  }

  return (
    <div className="">
      <div
        id="videoload"
        style={{
          width: "100px",
          height: "100px",
          margin: "auto",
          textAlign: "center",
          display: "none",
        }}
      >
        Loading...
      </div>
      {!props.videoUrlExt ? (
        <div id="videoframe" className="w-full">
          <iframe
            id="ccc"
            scrolling="no"
            src={url}
            title="Video Consultation"
            allow="camera; microphone; display-capture"
            className="w-full h-[280px] border-0"
          />
        </div>
      ) : null}
    </div>
  );
}

export default NewVideoConsult;

